/* eslint-disable jsx-a11y/control-has-associated-label */
const React = require('react');
const Snackbar = require('@andes/snackbar');
const Link16 = require('@andes/icons/Link16');
const FacebookSvg = require('../images/Facebook');
const TwitterSvg = require('../images/Twitter');
const LinkedinSvg = require('../images/Linkedin');
const { useI18n } = require('nordic/i18n');
const { getEventTracker } = require('../../../../../utils/event-tracker');

const { useState, useCallback } = React;

const ShareLink = ({ title }) => {
  const { i18n } = useI18n();
  const Tracker = getEventTracker();
  const [snackbarData, setSnackbarData] = useState({
    show: false,
    message: i18n.gettext('Copiado con éxito.'),
    type: 'green',
  });

  const track = action => Tracker.send(`mpdevelopers/news/${action}`);

  const copyToClipboard = () => {
    navigator.clipboard.writeText(window.location.href);
    track('click_copy_link');
    setSnackbarData({ ...snackbarData, show: true });
  };

  function twitterPost() {
    const text = `${title}: ${window.location.href}`;
    const mediaLink = `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}`;
    track('click_twitter_sharing');
    return mediaLink;
  }

  function facebookPost() {
    const mediaLink = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(window.location.href)}`;
    track('click_facebook_sharing');
    return mediaLink;
  }

  function linkedinPost() {
    const mediaLink = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(window.location.href)}`;
    track('click_linkedin_sharing');
    return mediaLink;
  }

  const onClick = useCallback((e, target) => {
    e.preventDefault();
    const targetWindow = window.open(target, 'popup', 'height=350,width=600');
    if (targetWindow && targetWindow.focus) {
      targetWindow.focus();
    }
  }, []);

  return (
    <div className="share-card-container">
      <div className="share-card-container__content">
        <button
          onClick={copyToClipboard}
          rel="noopener noreferrer"
          target="_blank"
          className="share-card-container__content-button-icon"
      >
          <Link16 />
        </button>
        <button
          onClick={(e) => { onClick(e, facebookPost()); }}
          rel="noopener noreferrer"
          target="_blank"
          className="share-card-container__content-button-icon"
        >
          <FacebookSvg />
        </button>
        <button
          onClick={(e) => { onClick(e, linkedinPost()); }}
          rel="noopener noreferrer"
          target="_blank"
          className="share-card-container__content-button-icon"
        >
          <LinkedinSvg />
        </button>
        <button
          onClick={(e) => { onClick(e, twitterPost()); }}
          rel="noopener noreferrer"
          target="_blank"
          className="share-card-container__content-button-icon"
        >
          <TwitterSvg />
        </button>
      </div>
      <Snackbar
        message={snackbarData?.message}
        color={snackbarData?.type}
        show={snackbarData?.show}
        delay={3000}
      />
    </div>
  );
};

export default ShareLink;
